import { CalendarDays, Clock, CloudSun, ListChecks } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "../api/client";
import type { TodayInfo } from "../api/types";
import { InfoRow } from "../components/InfoRow";
import { PageShell } from "../components/PageShell";
import {
  DEFAULT_ERROR_RECOVERY_ACTION,
  StatusBlock,
} from "../components/StatusBlock";
import styles from "../styles/App.module.css";
import { buildTodayFallback } from "../todayFallback";

export function TodayPage() {
  const [today, setToday] = useState<TodayInfo | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .today()
      .then(setToday)
      .catch((loadError) => {
        setError(
          loadError instanceof Error ? loadError.message : "读取今天信息失败。",
        );
        setToday(buildTodayFallback());
      });
  }, []);

  return (
    <PageShell title="今天信息" where="今天信息页">
      {error ? (
        <StatusBlock
          tone="error"
          message={error}
          recoveryAction={
            today
              ? "页面上仍可读取本机日期和时间；恢复网络后再返回今天信息读取后台提醒。"
              : DEFAULT_ERROR_RECOVERY_ACTION
          }
        />
      ) : null}
      {today ? (
        <div className={styles.commandList}>
          <InfoRow icon={CalendarDays} title={today.date_text} />
          <InfoRow icon={Clock} title={today.time_text} />
          <InfoRow
            icon={CloudSun}
            title={today.weather_location}
            hint={today.weather_summary}
          />
          <InfoRow
            icon={ListChecks}
            title="今日提醒"
            hint={
              today.reminders.length
                ? today.reminders.join("。")
                : "今天没有提醒"
            }
          />
        </div>
      ) : (
        <StatusBlock message="正在读取今天信息。" />
      )}
    </PageShell>
  );
}
